export const errorMsg = {
  sessionError: {
    code: 20002,
    msg: '',
  },
  sessionTimeout: {
    code: 20003,
    msg: '',
  },
  sessionFail: {
    code: 20004,
    msg: '',
  },
  knowledgePointNotExistError: {
    code: 20006,
    msg: 'chat_session_status_28',
  },
} as const;

/**
 * @param code
 */
// export const getErrorMsg = (code: number) => {
//   for (const key in errorMsg) {
//     if (Object.prototype.hasOwnProperty.call(errorMsg, key)) {
//       const item = errorMsg[key];
//       if (item.code === code) {
//         return item;
//       }
//     }
//   }
// };
